import { trackNextTripsArea } from '@/stores/track/trackNextTripsArea'
import { useTrack } from './useTrack'

export function useTrackNextTripsArea(
	area: string,
	{
		level = 0,
		interval = 30 * 1000,
	}: { level?: number; interval?: number } = {},
) {
	return useTrack(trackNextTripsArea, {
		area,
		level,
		interval,
	})
}
